import { Vector2, Vector3, Vector4 } from 'three';
import { MathV } from './MathV';

export class RationalCubicBezier
{
  static compute(  t:number,     
    p0:number, p1:number, p2:number, p3:number, 
    w0:number, w1:number, w2:number, w3:number
  ):number
  {
    let bp0 = ( 1 - t ) * ( 1 - t ) * ( 1 - t ) * w0;
    let bp1 = 3 * ( 1 - t ) * ( 1 - t ) * t * w1;
    let bp2 = 3 * ( 1 - t ) * t * t * w2;
    let bp3 = t * t * t * w3;

    let weighted = p0 * bp0 + p1 * bp1 + p2 * bp2 + p3 * bp3;

    let projection = bp0 + bp1 + bp2 + bp3;

    return weighted / projection;
  }

  public static compute2D( t:number, 
    p0:Vector2, p1:Vector2, p2:Vector2, p3:Vector2, 
    w0:number, w1:number, w2:number, w3:number
  ):Vector2
  {
    let bp0 = ( 1 - t ) * ( 1 - t ) * ( 1 - t ) * w0;
    let bp1 = 3 * ( 1 - t ) * ( 1 - t ) * t * w1;
    let bp2 = 3 * ( 1 - t ) * t * t * w2;
    let bp3 = t * t * t * w3;

    let weighted = MathV.multipliedSum(
      new Vector2(),
      [p0,bp0], [p1,bp1], [p2,bp2], [p3,bp3]
    );

    let projection = bp0 + bp1 + bp2 + bp3;

    return weighted.divideScalar( projection );
  }

  public static compute3D(  t:number, 
    p0:Vector3, p1:Vector3, p2:Vector3, p3:Vector3, 
    w0:number, w1:number, w2:number, w3:number
  ):Vector3
  {
    let bp0 = ( 1 - t ) * ( 1 - t ) * ( 1 - t ) * w0;
    let bp1 = 3 * ( 1 - t ) * ( 1 - t ) * t * w1;
    let bp2 = 3 * ( 1 - t ) * t * t * w2;
    let bp3 = t * t * t * w3;

    let weighted = MathV.multipliedSum(
      new Vector3(),
      [p0,bp0], [p1,bp1], [p2,bp2], [p3,bp3]
    );
    let projection = bp0 + bp1 + bp2 + bp3;

    return weighted.divideScalar( projection );
  }


  


  

  
}
